/* eslint-disable camelcase */
import _ from 'lodash';
import visa_master_icon from '../../../images/checkout/en/visa_mastercard.png';
import fawry from '../../../images/checkout/en/fawry.png';
import office from '../../../images/checkout/en/lynks_offices.png';
import bank from '../../../images/checkout/en/cib_bank.png';
import runner from '../../../images/checkout/en/bosta_new.svg';
import valu from '../../../images/checkout/en/valu.png';
// import mada from '../../../images/checkout/en/mada.png';

export const filterPaymentMethods = (
  payment_methods,
  locale,
  runner_available
) => {
  const allPaymentMethods = [
    {
      id: 'CreditCard',
      name: locale === 'ar' ? 'البطاقة الائتمانية' : 'Credit Card',
      icon: visa_master_icon,
      icon_size: 'small',
    },
    {
      id: 'Valu',
      name: locale === 'ar' ? 'تقسيط مع فاليو' : 'ValU',
      icon: valu,
      icon_size: 'small',
    },
    {
      id: 'Fawry',
      name: locale === 'ar' ? 'فوري' : 'Fawry',
      icon: fawry,
      icon_size: 'small',
    },
    {
      id: 'Office',
      name: locale === 'ar' ? 'مكتب لينكس' : 'Lynks Office',
      icon: office,
      icon_size: 'small',
    },
    {
      id: 'Runner',
      name: locale === 'ar' ? 'تحصيل من المنزل' : 'Pay from Home',
      icon: runner,
      icon_size: 'mini',
    },
    {
      id: 'BankDeposit',
      name: locale === 'ar' ? 'ايداع بنكي' : 'Bank Deposit',
      icon: bank,
      icon_size: 'small',
    },
  ];

  return _.filter(allPaymentMethods, (o) => {
    if (o.id === 'Runner') {
      return runner_available && payment_methods.includes(o.id);
    }
    return payment_methods.includes(o.id);
  });
};

export const reportConversionAnalytics = (
  payment_type,
  wrapper_number,
  total_usd
) => {
  if (payment_type === 'CreditCard') {
    sendGoogleAnalyticsTrackingInfo(total_usd, wrapper_number, 'Credit Card');
    sendFacebookPixelTrackingInfo(total_usd, 'Credit Card');
    sendAdwordsConversion(total_usd, wrapper_number, '6lwHCMrLv4wBEMy3qJwD');
  } else {
    sendGoogleAnalyticsTrackingInfo(
      total_usd,
      wrapper_number,
      'Waiting For Payment'
    );
    sendFacebookPixelTrackingInfo(total_usd, 'Waiting For Payment');
    sendAdwordsConversion(total_usd, wrapper_number, 'SDxuCJztm6gBEMy3qJwD');
  }
};

export const sendGoogleAnalyticsTrackingInfo = (
  total_usd,
  wrapper_number,
  payment_type
) => {
  if (process.env.NODE_ENV === 'production') {
    gtag('event', 'purchase', {
      transaction_id: wrapper_number,
      affiliation: `Lynks ${payment_type}`,
      value: total_usd,
      currency: 'USD',
    });
  }
};

export const sendAdwordsConversion = (
  total_usd,
  wrapper_number,
  adwords_conversion_id
) => {
  if (process.env.NODE_ENV === 'production') {
    const callback = () => {
      if (typeof url !== 'undefined') {
        window.location = url;
      }
    };
    gtag('event', 'conversion', {
      send_to: `AW-864689100/${adwords_conversion_id}`,
      value: total_usd,
      currency: 'USD',
      transaction_id: wrapper_number,
      event_callback: callback,
    });
    return false;
  }
};

export const sendFacebookPixelTrackingInfo = (total_usd, payment_type) => {
  if (process.env.NODE_ENV === 'production') {
    fbq('track', 'Purchase', {
      currency: 'USD',
      value: total_usd,
      payment_type,
    });
  }
};



// WEBPACK FOOTER //
// ./app/containers/Checkout/Helpers/actions.js